export const setStateFromJson = (initialData) => {
  return {
    type: 'SET_STATE_FROM_JSON',
    payload: {newState: initialData}
  };
};

export const updateTextField = (name, value, inOnChange = false) => {
  return {
    type: 'UPDATE_TEXT_FIELD',
    payload: {
      name,
      value,
      inOnChange
    }
  };
};

export const changeDurationValue = value => ({
  type: 'CHANGE_DURATION_VALUE',
  payload: {value}
});

export const changeScanDaysValue = value => ({
  type: 'CHANGE_SCANDAYS_VALUE',
  payload: {value}
});

export const showResortErrorMessage = (show) => ({type: 'SHOW_RESORT_ERROR_MESSAGE', payload: {show}});

export const updateDate = (date, endDate = null) => {
  return {
    type: 'UPDATE_DATE',
    payload: {
      date,
      endDate
    }
  };
};

export const updateDiamondAndAvailproCodes = () => {
  return {
    type: 'UPDATE_DIAMOND_AND_AVAILPRO_CODES'
  };
};
